import type { ReactNode } from "react";
import SmartLink from "./SmartLink";

type Variant =
  | "primary"
  | "outline"
  | "outline-dark"
  | "dark"
  | "blue"
  | "green"
  | "purple"
  | "orange"
  | "gold"
  | "periwinkle"
  | "teal";

// Brand kit: "opt for darker shades for buttons and CTAs" + ADA contrast —
// #b54437 passes AA with white text; #cd5144 does not. Blue/green variants
// power the accent-colored audience pages (Builders blue, Parents green).
const styles: Record<Variant, string> = {
  primary: "bg-hxp-red-dark text-white hover:bg-[#9d382e]",
  outline:
    "border border-hxp-sand-dark bg-transparent text-foreground hover:bg-hxp-cream-2",
  "outline-dark":
    "border border-white/40 bg-transparent text-white hover:bg-white hover:text-foreground",
  dark: "bg-foreground text-background hover:bg-foreground/85",
  blue: "bg-hxp-blue-dark text-white hover:bg-[#3a5560]",
  green: "bg-hxp-olive text-white hover:bg-hxp-olive-dark",
  purple: "bg-hxp-purple text-white hover:bg-hxp-purple-dark",
  orange: "bg-hxp-orange text-white hover:bg-hxp-orange-dark",
  // Gold and periwinkle from marketing's Experiences graphic (AA with white text).
  gold: "bg-[#8a6e2f] text-white hover:bg-[#735b25]",
  periwinkle: "bg-[#5f6db5] text-white hover:bg-[#4d5a9c]",
  // Palette dark teal (marketing, Nov 2026); AA with white text.
  teal: "bg-[#193f49] text-white hover:bg-[#12303a]",
};

/** Become-theme button: square corners, Oswald caps, letter-spaced. */
const Btn = ({
  href,
  variant = "primary",
  children,
  className = "",
}: {
  href: string;
  variant?: Variant;
  children: ReactNode;
  className?: string;
}) => (
  <SmartLink
    href={href}
    className={`btn-caps inline-flex items-center justify-center rounded-sm px-8 py-3 text-sm transition-colors ${styles[variant]} ${className}`}
  >
    {children}
  </SmartLink>
);

export default Btn;
